export const GET_HOME_DASHBOARD_STATS =
	'GET_HOME_DASHBOARD_STATS';
export const GET_HOME_DASHBOARD_STATS_SUCCESS =
	'GET_HOME_DASHBOARD_STATS_SUCCESS';
export const GET_HOME_DASHBOARD_STATS_FAIL = 'GET_HOME_DASHBOARD_STATS_FAIL';
export const HOME_DOWNLOAD = 'HOME_DOWNLOAD';
export const SHOW_HOME_DOWNLOAD_SUCCESS_ALERT = 'SHOW_HOME_DOWNLOAD_SUCCESS_ALERT';
export const INITIAL_HOME_DASHBOARD_VISIT = 'INITIAL_HOME_DASHBOARD_VISIT'